import { Module } from "@/types/module.interfaces";

export function flattenModules(modules: Module[]) {
  if (!modules || !Array.isArray(modules)) return [];

  return modules.flatMap(mod =>
    mod.features?.map(feature => ({
      moduleTitle: mod.title,
      modulePath: mod.path,
      ...feature
    })) ?? []
  );
}
